export default {
  labelActive () {
    return this.rule.active ? 'publicado' : 'Aguardando Publicação'
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/resources/computed.js